import { latFromMercatorY, lngFromMercatorX, mercatorXfromLng, mercatorYfromLat } from './mercator-utils';

export function generateRectangularMesh(bounds: [number, number, number, number], forZoom: number) {
    const worldSubdivisions = Math.max(1, 128 / (1 << forZoom));

    const vertices: number[] = [];
    const texCoords: number[] = [];
    const indices: number[] = [];
    const lngSpan = bounds[2] - bounds[0];
    const latSpan = bounds[3] - bounds[1];

    const subdivisionsX = Math.max(1, Math.ceil((lngSpan / 360) * worldSubdivisions));
    const subdivisionsY = Math.max(1, Math.ceil((latSpan / 180) * worldSubdivisions));

    const minX = mercatorXfromLng(bounds[0]);
    const minY = mercatorYfromLat(Math.max(-85, bounds[1]));
    const maxX = mercatorXfromLng(bounds[2]);
    const maxY = mercatorYfromLat(Math.min(85, bounds[3]));

    const stepX = (maxX - minX) / Math.max(1, subdivisionsX - 1);
    const stepY = (maxY - minY) / Math.max(1, subdivisionsY - 1);

    for (let y = 0; y < subdivisionsY; y++) {
        const lat = (bounds[3] - latFromMercatorY(minY + y * stepY)) / latSpan;
        for (let x = 0; x < subdivisionsX; x++) {
            const lng = 1 - (bounds[2] - lngFromMercatorX(minX + x * stepX)) / lngSpan;
            vertices.push(minX + x * stepX);
            vertices.push(minY + y * stepY);
            texCoords.push(lng);
            texCoords.push(lat);
        }
    }

    for (let y = 0; y < subdivisionsY - 1; y++) {
        for (let x = 0; x < subdivisionsX - 1; x++) {
            // prettier-ignore
            indices.push(
                y * subdivisionsX + x,
                y * subdivisionsX + x + 1,
                (y + 1) * subdivisionsX + x);

            // prettier-ignore
            indices.push(
                y * subdivisionsX + x + 1,
                (y + 1) * subdivisionsX + x + 1,
                (y + 1) * subdivisionsX + x);
        }
    }

    return {
        verticesFlattened: vertices,
        triangleIndices: indices,
        texCoords: texCoords
    };
}
